export default {"src":"/login-app/[GIT_HASH]/_next/static/media/nightlight.2a4daec9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};